import React from 'react';

const ArrowRight = props => (
  <img {...props} src={`${MEDIA_ROOT}/icons/icn_arrowright.svg`} alt="Arrow right" />
);

export default ArrowRight;
